import {TreatmentEndoToothGroupToothDataModel} from './treatment-endo-tooth-group-tooth-data.model';
import {XauditModel} from '../../../models/xaudit.model';

export class TreatmentEndoToothGroupDataModel {//extends XauditModel {
  ToothGroupID: string;
  PatientId: string;
  Description: string;

 //dataTreatmentEndoToothGroupTeeth: TreatmentEndoToothGroupToothDataModel[];
}

export class TreatmentEndoToothGroupModel extends XauditModel {//extends XauditModel {
  ToothGroupID: string;
  PatientId: string;
  Description: string;

 dataTreatmentEndoToothGroupTeeth: TreatmentEndoToothGroupToothDataModel[];
}


export class TreatmentEndoToothGroupDataTable extends XauditModel {
  ToothGroupId: string;
  ToothGroupToothID: string;
  CaseWorkItemToothId: string;
  DayOfVisit: Date;
  ToothGroupDescription: string;
  patientId: string;
  isInGroup: boolean;
  Tooth: string;
  ToothId: string;
}
